import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/idle_fee_bills',
  component: Management,
  redirect: '/idle_fee_bills/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/idle_fee_bills/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listIdleFeeBills
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/idle_fee_bills/ListTable'),
          meta: {
            auth: Auth.listIdleFeeBills,
            tabName: 'all'
          }
        },
        {
          path: 'unpaid',
          component: () => import('@/views/idle_fee_bills/ListTable'),
          meta: {
            auth: Auth.listIdleFeeBills,
            tabName: 'unpaid'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/idle_fee_bills/DetailLayout'),
      meta: {
        auth: Auth.showIdleFeeBill
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/idle_fee_bills/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showIdleFeeBill
          }
        }
      ]
    }
  ]
}
